import { useTranslation } from "react-i18next";
import Link from "@/components/feature/LocaleLink";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useSeo } from "@/lib/useSeo";

export default function NotFound() {
  const { t } = useTranslation();
  // 없는 주소는 색인되지 않도록
  useSeo({ title: t("notfound.title"), description: t("notfound.desc"), noindex: true });

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900 flex flex-col">
      <Navbar />
      <main className="flex-1 flex flex-col items-center justify-center text-center px-4 pt-20">
        <div className="font-heading text-7xl md:text-9xl font-black text-background-200 select-none">404</div>
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-2">{t("notfound.title")}</h1>
        <p className="mt-3 text-foreground-600 max-w-md">{t("notfound.desc")}</p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          {t("notfound.home")}
        </Link>
      </main>
      <Footer />
    </div>
  );
}
